module.exports = __webpack_public_path__ + "img/8.f49ea9e6.png";